export var QUERY_SEPARATOR = '?';
export var QUERY_PARAM_SEPARATOR = '&';
export var LANG_QUERY_PARAM = 'lang=';
export var QUERY_WHITELIST = [LANG_QUERY_PARAM, 'lightbox='];
export var PATTERN_PREFIX = '{{';
export var SELF_REF_PATTERN_PREFIX = '{{@';
export var PATTERN_SUFFIX = '}}';
export var WIX_DOMAINLESS_IDS = [
    'wixsite.com',
    'editor.wix.com',
    'editorx.io',
];
export var INDEX = 'index';
export var NO_INDEX = 'noindex';
